/**
 * @group CSS Class
 */
export const NOVA_SCROLL_REQUEST = 'nova-scroll-request';
